export const environment = {
  production: true,
  publicDevKey: 'BGjJfpwIFV4mPatdHfF3JfGd5Xd7V05w40JI-BGo-U_HrXgd_z0ctV2vTSlw_g1XbERHepImmqp7qRWG0bL0JB8'
};
